import { useLanguage } from '../../contexts/LanguageContext';
import { IS_DEMO } from '../../apiBase';
import { createDocEntryStore } from './docStore';
import { readState, writeState } from './docState';
import { SegmentedToggle } from './SegmentedToggle';

// THE SIGN-OFFS OF THE TWO VIEWS THAT ARE NO SUB-STEP: the product assembled ("End") and the whole
// assembly played through ("All"). One key, kept with the manual like every answer.
export type Signoffs = { end?: boolean; all?: boolean };
const key = (docId: string) => `notice.assembly.signoffs.${docId}`;
const store = createDocEntryStore<Signoffs>((docId) => ({ snapshot: readState<Signoffs>(docId, key(docId), {}) }));

export const useSignoffs = (docId: string): Signoffs => store.useSnapshot(docId);

const signOff = (docId: string, which: keyof Signoffs, on: boolean) => {
  const next = { ...store.get(docId), [which]: on };
  store.patch(docId, next);
  writeState(docId, key(docId), next);
};

// THE SAME TOGGLE A SUB-STEP IS SIGNED OFF WITH.
export function SignoffToggle({ docId, which }: { docId: string; which: keyof Signoffs }) {
  const { t } = useLanguage();
  const on = !!useSignoffs(docId)[which];
  if (IS_DEMO) return null;
  return (
    <div className="flex justify-center">
      <SegmentedToggle
        value={on ? 'yes' : 'no'}
        options={[
          { value: 'no', label: t('notice.assembly.unvalidated') },
          { value: 'yes', label: t('notice.assembly.validated') },
        ]}
        onChange={(v) => signOff(docId, which, v === 'yes')}
      />
    </div>
  );
}
